import { getDeep } from '@shared/utils/getDeep.js';
import { setDeep } from '@shared/utils/setDeep.js';
import { action } from '@/lib/api.js';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem.js';
import { store } from '@/redux/lib/configureStore';
import selectors from '@/redux/selectors/selectors.js';

const companyActions = {
  set(path, payload, explicitCompanyId) {
    return new Promise((resolve) => {
      const state = store.getState();
      const companyId = explicitCompanyId ?? state?.user?.jwt?.companyId;
      const activeCompany = selectors.activeCompany(state);
      if (explicitCompanyId !== undefined && activeCompany?.id !== explicitCompanyId) {
        resolve();
        return;
      }
      const newCompany = setDeep(activeCompany, path, payload);
      const value = getDeep(path, newCompany);

      action('PUT_COMPANY', newCompany);
      pushChangesQueueItem('company', { companyId, path, value });

      resolve();
    });
  }
};

export default companyActions;
